import Swal from 'sweetalert2';

// Configuración por defecto para SweetAlert2 — Brand-aligned
const defaultConfig = {
  confirmButtonColor: '#1a1a1a',
  cancelButtonColor: '#d4cdc4',
  confirmButtonText: 'Aceptar',
  cancelButtonText: 'Cancelar',
  reverseButtons: true
};

// Alerta de éxito
export const showSuccess = (message, title = '¡Listo!') => {
  return Swal.fire({
    ...defaultConfig,
    icon: 'success',
    title: title,
    text: message,
    confirmButtonText: 'Aceptar'
  });
};

// Alerta de error
export const showError = (message, title = 'Error') => {
  return Swal.fire({
    ...defaultConfig,
    icon: 'error',
    title: title,
    text: message,
    confirmButtonText: 'Aceptar'
  });
};

// Alerta de información
export const showInfo = (message, title = 'Información') => {
  return Swal.fire({
    ...defaultConfig,
    icon: 'info',
    title: title,
    text: message,
    confirmButtonText: 'Aceptar'
  });
};

// Alerta de advertencia
export const showWarning = (message, title = 'Advertencia') => {
  return Swal.fire({
    ...defaultConfig,
    icon: 'warning',
    title: title,
    text: message,
    confirmButtonText: 'Aceptar'
  });
};

// Confirmación con botones personalizables
export const showConfirm = (title = '¿Estás seguro?', message = '', confirmText = 'Confirmar', cancelText = 'Cancelar') => {
  return Swal.fire({
    ...defaultConfig,
    icon: 'warning',
    title: title,
    text: message,
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText
  });
};

// Confirmación para eliminar
export const showDeleteConfirm = (message = '¿Estás seguro de que quieres eliminar este elemento?') => {
  return Swal.fire({
    ...defaultConfig,
    icon: 'warning',
    title: '¿Eliminar?',
    text: message,
    showCancelButton: true,
    confirmButtonColor: '#1a1a1a',
    confirmButtonText: 'Eliminar',
    cancelButtonText: 'Cancelar'
  });
};

// Toast notification (pequeña notificación)
export const showToast = (message, icon = 'success') => {
  return Swal.fire({
    toast: true,
    position: 'top-end',
    icon: icon,
    title: message,
    showConfirmButton: false,
    timer: 2500,
    timerProgressBar: true,
    background: getComputedStyle(document.documentElement).getPropertyValue('--brand-primary').trim() || '#1a1a1a',
    color: '#ffffff',
    iconColor: '#ffffff',
    width: 'auto',
    padding: '0.5rem 1rem',
    customClass: {
      popup: 'colored-toast',
      title: 'toast-title'
    },
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
  });
};

// Toast de carrito agregado (específico para agregar al carrito)
export const showCartToast = (productName = '') => {
  const message = productName 
    ? `${productName} agregado al carrito` 
    : '¡Producto agregado al carrito!';
  
  return Swal.fire({
    toast: true,
    position: 'top-end',
    icon: 'success',
    title: message,
    showConfirmButton: false,
    timer: 2500,
    timerProgressBar: true,
    background: getComputedStyle(document.documentElement).getPropertyValue('--brand-primary').trim() || '#1a1a1a',
    color: '#ffffff',
    iconColor: '#ffffff',
    width: 'auto',
    padding: '0.5rem 1rem',
    customClass: {
      popup: 'colored-toast',
      title: 'toast-title'
    },
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
  });
};
